import Swiper from 'swiper';
import {add_swiper_class} from '@otrocheyon/js/tools/swiper';

export default class Slider {

    constructor() {
        Slider.hero();
        Slider.slider_strate_voyage();
        Slider.slider_strate_highlight();
        Slider.slider_post();
        Slider.slider_agenda();
        Slider.slider_related_post();
    }

    static add_swiper_class(container, wrapper, item) {
        $(container).addClass('swiper-container');
        $(wrapper).addClass('swiper-wrapper');
        $(item).addClass('swiper-slide');
    }

    static hero() {
        const slider = '[data-id="wpiris-hero-slider"]',
            slider_wrapper = '[data-id="wpiris-hero-slider-wrapper"]',
            slider_item = '[data-id="wpiris-hero-slider-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                autoplay: {},
                speed: 600,
                slidesPerView: 1,
                loop: true,
                lazy: true,
                pagination: {
                    el: '[data-trigger="swiper-dots"]',
                    clickable: true,
                },
            });
        }
    }

    static slider_strate_voyage() {
        const slider = '[data-id="wpiris-voyage"]',
            slider_wrapper = '[data-id="wpiris-voyage-wrapper"]',
            slider_item = '[data-id="wpiris-voyage-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {},
                speed: 600,
                slidesPerView: 1,
                loop: true,
                lazy: true,
                pagination: {
                    el: '[data-trigger="swiper-dots-voyage"]',
                    clickable: true,
                },
            });
        }
    }

    static slider_strate_highlight() {
        const slider = '[data-id="wpiris-highlightHome"]',
            slider_wrapper = '[data-id="wpiris-highlightHome-wrapper"]',
            slider_item = '[data-id="wpiris-highlight-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                speed: 600,
                slidesPerView: 1,
                spaceBetween: 10,
                loop: false,
                lazy: true,
                navigation: {
                    nextEl: '.swiperNav .swiper-button-next',
                    prevEl: '.swiperNav .swiper-button-prev',
                },
                breakpoints: {
                    750: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    },
                }
            });
        }
    }

    static slider_post() {
        const slider = '[data-id="wpiris-postHome"]',
            slider_wrapper = '[data-id="wpiris-postHome-wrapper"]',
            slider_item = '[data-id="wpiris-postHome-item"]';

        if ($(slider).length > 0) {

            if ((window.matchMedia("(max-width: 750px)").matches && $(slider_item).length > 2)) {

                add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

                new Swiper($(slider), {
                    mousewheel: {
                        forceToAxis: true,
                    },
                    spaceBetween: 10,
                    freeMode: true,
                    loop: true,
                    lazy: true,
                    speed: 600,
                    slidesPerView: 1,
                    pagination: {
                        el: '[data-trigger="swiper-dots-postHome"]',
                        clickable: true,
                    },
                });
            }
        }
    }

    static slider_agenda() {
        const slider = '[data-id="wpiris-agenda"]',
            slider_wrapper = '[data-id="wpiris-agenda-wrapper"]',
            slider_item = '[data-id="wpiris-agenda-item"]';

        if ($(slider).length > 0) {

            if ((window.matchMedia("(max-width: 750px)").matches && $(slider_item).length > 2)) {

                add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

                new Swiper($(slider), {
                    mousewheel: {
                        forceToAxis: true,
                    },
                    spaceBetween: 10,
                    freeMode: true,
                    loop: false,
                    lazy: true,
                    speed: 600,
                    slidesPerView: 1,
                });
            }
        }
    }

    static slider_related_post() {
        const slider = '[data-id="wpiris-relatedpost"]',
            slider_wrapper = '[data-id="wpiris-relatedpost-wrapper"]',
            slider_item = '[data-id="wpiris-relatedpost-item"]';

        if ($(slider).length > 0) {

            add_swiper_class($(slider), $(slider_wrapper), $(slider_item));

            new Swiper($(slider), {
                mousewheel: {
                    forceToAxis: true,
                },
                keyboard: true,
                spaceBetween: 10,
                freeMode: true,
                speed: 600,
                slidesPerView: 2,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    450: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    750: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1450: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    }
                }
            });
        }
    }
}